import React, { useState, useEffect } from "react";
import { FaStar, FaRegStar, FaQuoteLeft, FaCertificate, FaUsers, FaTrophy, FaList, FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { Carousel } from "react-bootstrap";

const TestimonialSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 3); // Change the slide every 5 seconds
    }, 5000);
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  return (
    <section className="hm8TestimonialSection">
      <div className="home8-testi-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12 hm8CounterCol">
              <div className="icon_counter first">
                <div className="row">
                  <div className="col-md-4 col-sm-4 col-xs-4">
                    <FaCertificate size={30} />
                  </div>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <h3 className="counter">24</h3>
                    <h3>+</h3>
                    <h4>Certified Engineer</h4>
                  </div>
                </div>
              </div>
              <div className="icon_counter second">
                <div className="row">
                  <div className="col-md-4 col-sm-4 col-xs-4">
                    <FaUsers size={30} />
                  </div>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <h3 className="counter">1800</h3>
                    <h3>+</h3>
                    <h4>Worldwide Clients</h4>
                  </div>
                </div>
              </div>
              <div className="icon_counter third">
                <div className="row">
                  <div className="col-md-4 col-sm-4 col-xs-4">
                    <FaTrophy size={30} />
                  </div>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <h3 className="counter">15</h3>
                    <h3>+</h3>
                    <h4>Our Expertise</h4>
                  </div>
                </div>
              </div>
              <div className="icon_counter last">
                <div className="row">
                  <div className="col-md-4 col-sm-4 col-xs-4">
                    <FaList size={30} />
                  </div>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <h3 className="counter">150</h3>
                    <h3>+</h3>
                    <h4>Projects Completed</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12 hm8TestimonialCol">
  <div className="hm8Testimonial testimonialArea">
    <Carousel activeIndex={activeIndex} onSelect={setActiveIndex} interval={5000} controls={true}>
      <Carousel.Item>
        <div className="testimonialText">
          <FaQuoteLeft size={20} />
          <p>
            "Anjali Enterprises provided excellent glass partitions for our office. Their attention to detail in the design and installation of the toughened glass partitions was beyond expectations. The workspace now looks sleek and modern, and we couldn't be happier!"
          </p>
        </div>
        <div className="hm8TestimonialContent">
          <h5>Miss. Priya Mehta</h5>
          <p className="desig">Office Manager</p>
          <span className="testi-star">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaRegStar />
            <FaRegStar />
          </span>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="testimonialText">
          <FaQuoteLeft size={20} />
          <p>
            "We were looking for a soundproof glass window solution for our meeting rooms, and Anjali Enterprises delivered. The quality of their products and installation was exceptional. The rooms are now much quieter, and we can have productive meetings without distractions."
          </p>
        </div>
        <div className="hm8TestimonialContent">
          <h5>Mr. Amit Patel</h5>
          <p className="desig">Project Manager</p>
          <span className="testi-star">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaRegStar />
          </span>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="testimonialText">
          <FaQuoteLeft size={20} />
          <p>
            "We hired Anjali Enterprises for the installation of aluminium glass windows and ACP cladding panels in our building. The team was professional, the work was completed on time, and the results are fantastic. The building looks great, and the windows have significantly improved insulation."
          </p>
        </div>
        <div className="hm8TestimonialContent">
          <h5>Mr. Rajesh Kumar</h5>
          <p className="desig">Building Contractor</p>
          <span className="testi-star">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
          </span>
        </div>
      </Carousel.Item>
    </Carousel>
  </div>
</div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
